import React, { FC } from 'react';

import { applyColor, applyRadius, applySize } from './logic';
import { classNames } from '../../../../growth-platform-brand-system-v2/src/utils/style';

export interface TagProps {
  title: string;
  type?: 'filled' | 'outlined' | 'default';

  color?: 'azur' | 'blue' | 'coral' | 'mint' | 'neutral' | 'purple' | 'yellow';
  isDark?: boolean;
  isSquared?: boolean;
  size?: 'big' | 'mid' | 'small';
  className?: string;
  isUppercase?: boolean;
}

export const Tag: FC<TagProps> = ({
  title,
  type = 'filled',
  color = 'blue',
  isDark = false,
  isSquared = false,
  size = 'mid',
  className,
  isUppercase = true,
}) => {
  return (
    <span
      className={classNames(
        'Tag',
        applyColor(color, type, isDark),
        applySize(size, isUppercase),
        applyRadius(isSquared),
        'inline-flex items-center whitespace-nowrap',
        className ? className : '',
      )}
    >
      {title}
    </span>
  );
};
